import type {
  SubEntryType,
  Entry as UserEntry,
} from "@tandemdiabetes/sugarmate-api-react-client"
import type { MangoQuery } from "rxdb"
import { createEntryQueryObject } from "./createEntryQueryObject"

const defaultSelector = {}

// adds "subentry_type" selector to entry query
export function createEntryQueryObjectForType<T extends SubEntryType>(
  accountId: number | undefined,
  activityType: T | T[],
  {
    selector,
    sort,
    limit,
  }: MangoQuery<UserEntry>,
) {
  return createEntryQueryObject(
    accountId,
    {
      selector: {
        subentries: {
          $elemMatch: {
            subentry_type: (
              Array.isArray(activityType)
                ? { $in: activityType }
                : { $eq: activityType }
            ),
          },
        },
        ...(selector ?? defaultSelector),
      },
      sort,
      limit,
    },
  )
}
